const initialState = {
  accessToken: null,
  menus: [],
  userName: null,
  profileImage: null,
  userEmail: null,
  googleApiTime: null,
};

const profileReducer = (state = initialState, action) => {
  if (action.type === "ACCESS_TOKEN") {
    return {
      ...state,
      accessToken: action.payload,
    };
  } else if (action.type === "MENU") {
    return {
      ...state,
      menus: action.payload,
    };
  } else if (action.type === "USER_NAME") {
    return {
      ...state,
      userName: action.payload,
    };
  } else if (action.type === "UPDATE_PROFILE_IMAGE") {
    return {
      ...state,
      profileImage: action.payload,
    };
  } else if (action.type === "USER_EMAIL") {
    return {
      ...state,
      userEmail: action.payload,
    };
  } else if (action.type === "GOOGLE_API_TIME") {
    return {
      ...state,
      googleApiTime: action.payload,
    };
  } else if (action.type === "RESET_STATE") {
    return initialState;
  } else {
    return state;
  }
};

export default profileReducer;
